import React, { Component } from 'react';
import v from 'vudu';
import Text from 'components/Text';
import get from 'utils/get';
import Tick from 'components/svgs/Tick';
import { withRouter } from 'react-router-dom';
import { TweenLite, TimelineLite } from 'gsap';
import EasePack from 'gsap/EasePack';
import now from 'utils/now';
import importAll from 'utils/importAllFromFolder';
import { format as f, colors } from 'stylesheet';

const images = importAll(require.context('assets/asteroid-slowed', false, /\.(png)$/));
const greenImages = importAll(require.context('assets/asteroid-slowed-green', false, /\.(png)$/));

const imageWidth = 36;
const ANIMATION_DURATION = 1;

const localClasses = v({
  progressBar: {
    position: 'absolute',
    top: 0,
    marginTop: '30px',
    maxWidth: '100%',
    width: '500px',
    zIndex: 5,
    overflowX: 'scroll',
    transform: 'translateX(50%)',
    right: '50%',
  },
  circleContainer: {
    position: 'relative',
    cursor: 'pointer'
  },
  labels: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0px 12px',
    height: '30px',
    alignItems: 'flex-end'
  },
  label: {
    width: '68px',
    textAlign: 'center'
    //position: 'absolute',
    //top: '-28px',
    //left: '-100%'
  },
  progressBarInner: {
    width: '440px',
    margin: 'auto',
    zIndex: 9999,
  },
  asteroid: {
    zIndex: 6,
    width: `${imageWidth}px`,
    height: `${imageWidth}px`,
    backgroundImage: `url(${images[0]})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    top: '30px'
  },
  bars: {
    display: 'flex',
    alignItems: 'center',
    margin: `0 ${imageWidth}px`,
    height: '36px'
  },
  circle: {
    width: `${imageWidth/2}px`,
    height: `${imageWidth/2}px`,
    backgroundColor: '#F7256B',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inactive: {
    border: '2.5px solid rgba(247, 37, 107, 0.27)',
    backgroundColor: 'transparent'
  },
  line: {
    margin: '0 4px',
    height: '3px',
    backgroundColor: 'rgba(247, 37, 107, 0.27)',
    flexGrow: 1,
    flexBasis: 0
  }
});

const overrideClasses = v({
  greenOverride: {
    [`.${localClasses.label}`]: {
      color: colors.green
    },
    [`.${localClasses.line}`]: {
      backgroundColor: colors.green
    },
    [`.${localClasses.inactive}`]: {
      borderColor: `rgba(37, 247, 195, 0.27)`,
      backgroundColor: 'transparent !important'
    },
    [`.${localClasses.circle}:not(.${localClasses.inactive})`]: {
      borderColor: colors.green,
      backgroundColor: colors.green
    },
  }
});

const Stages = {
  SIGNUP: '/',
  SURVEY: '/questionnaire',
  QUALIFY: '/qualify',
  BONUS: '/bonus'
}
const stageUrls = Object.keys(Stages).map(key => Stages[key]);
const [, ...shownUrls] = stageUrls;

const Variants = {
  GREEN: 'green',
  PINK: 'pink'
}

const ProgressCircle = (props) => {
  if (stageUrls.indexOf(props.current) > stageUrls.indexOf(props.stage)) {
    return <div className={localClasses.circle} ref={props.circRef}><Tick /></div>
  }
  return <div className={`${localClasses.circle} ${localClasses.inactive}`} ref={props.circRef}></div>
}

export default withRouter(class ProgressBar extends Component {
  constructor(props) {
    super(...arguments);
    this[Stages.SIGNUP]  = { label: null, circle: null }
    this[Stages.SURVEY]  = { label: null, circle: null }
    this[Stages.QUALIFY] = { label: null, circle: null }
    this[Stages.BONUS]   = { label: null, circle: null }
    this.state = { variant: Variants.PINK }
  }

  componentDidMount() {
    /* Pre-hide if necessary */
    if (!shownUrls.includes(get(this, 'props.location.pathname'))) {
      (new TimelineLite()).to(this.inner, 0, { opacity: 0, y: -10 });
    }
    this.startAsteroidSpinning();
    this.animateAsteroid();
  }

  componentWillReceiveProps(nextProps) {
    this.animateAsteroid(get(this, 'props.location.pathname'), get(nextProps, 'location.pathname'));
  }

  animateAsteroid(from = Stages.SIGNUP, to = get(this, 'props.location.pathname')) {
    if (this.timeline) this.timeline.stop();
    /* Handle Self */
    this.timeline = new TimelineLite();
    if (shownUrls.includes(from) && !shownUrls.includes(to)) {
      /* Will Hide */
      this.timeline.fromTo(this.inner, 0, { opacity: 1, y: 0 }, { opacity: 0, y: -10 });
    } else if (!shownUrls.includes(from) && shownUrls.includes(to)) {
      /* Will Show */
      this.timeline.fromTo(this.inner, ANIMATION_DURATION, { opacity: 0, y: -10 }, { opacity: 1, y: 0, ease: EasePack.Expo.easeInOut });
    }
    /* Handle case when coming from /terms */
    if (!stageUrls.includes(from)) from = Stages.SIGNUP;
    /* Handle case when going to /terms */
    if (!stageUrls.includes(to)) return;

    let finalX = (this[to].circle.getBoundingClientRect().left - (imageWidth/4)) - this.inner.getBoundingClientRect().left;

    let willTransitionToLastHalf =
      [Stages.SIGNUP, Stages.SURVEY].includes(from) && [Stages.QUALIFY, Stages.BONUS].includes(to);

    let willTransitionToFirstHalf =
      [Stages.SIGNUP, Stages.SURVEY].includes(to) && [Stages.QUALIFY, Stages.BONUS].includes(from);

    this.timeline
      .to(this.asteroid, ANIMATION_DURATION, { x: finalX, ease: EasePack.Expo.easeInOut }, 's')
      .to(this[to].circle, ANIMATION_DURATION/2, { scale: 0.1, ease: EasePack.Expo.easeOut }, 's+=0.25')
      .to(this[to].label, ANIMATION_DURATION/2, { y: -10, ease: EasePack.Expo.easeIn }, 's+=0.25')
      .fromTo(this[from].circle, ANIMATION_DURATION/2, { scale: 0.1 }, { scale: 1, ease: EasePack.Expo.easeIn }, 's')
      .fromTo(this[from].label, ANIMATION_DURATION/2, { y: -10 }, { y: 0, ease: EasePack.Expo.easeIn }, 's+=0.25')

    if (willTransitionToLastHalf) {
      this.timeline.to(this.ref, 0.5, { scrollTo: { x: 100 }}, 's');
      this.setState({ variant: Variants.GREEN });
    }
    if (willTransitionToFirstHalf) {
      this.timeline.to(this.ref, 0.5, { scrollTo: { x: 0 }}, 's');
      this.setState({ variant: Variants.PINK });
    }
  }

  attemptPush = to => {
    if (stageUrls.indexOf(to) < stageUrls.indexOf(this.props.location.pathname))
      this.props.history.push(to);
  }

  startAsteroidSpinning() {
    let fps          = 30,
        currentFrame = 0,
        ref          = this.asteroid,
        instance     = this,
        currentTime  = now();
    (function animloop(time){
      let imagesArray = instance.state.variant === Variants.PINK ? images : greenImages;
      let delta = (time - currentTime) / 1000;
      currentFrame += (delta * fps);
      let frameNum = Math.floor(currentFrame);
      if (frameNum >= imagesArray.length) currentFrame = frameNum = 0;
      requestAnimationFrame(animloop);
      ref.style.backgroundImage = `url(${imagesArray[frameNum]})`;
      currentTime = time;
    })(currentTime);
  }

  render() {
    let useGreen = this.state.variant === Variants.GREEN;

    let classes = localClasses.progressBar;
    if (useGreen) classes += ` ${overrideClasses.greenOverride}`;

    return (
      <div className={classes} ref={r => this.ref = r}>
        <div className={localClasses.progressBarInner} ref={r => this.inner = r}>
          <div className={localClasses.asteroid} ref={r => this.asteroid = r}></div>

          <div className={localClasses.labels}>
            <Text
              variant={'smallTracked'}
              color={'razzmatazz'}
              classes={localClasses.label}
              textRef={r => this[Stages.SIGNUP].label = r }
            >Signup</Text>
            <Text
              variant={'smallTracked'}
              color={'razzmatazz'}
              classes={localClasses.label}
              textRef={r => this[Stages.SURVEY].label = r}
            >Survey</Text>
            <Text
              variant={'smallTracked'}
              color={'razzmatazz'}
              classes={localClasses.label}
              textRef={r => this[Stages.QUALIFY].label = r}
            >Qualify</Text>
            <Text
              variant={'smallTracked'}
              color={'razzmatazz'}
              classes={localClasses.label}
              textRef={r => this[Stages.BONUS].label = r}
            >Bonus</Text>
          </div>

          <div className={localClasses.bars}>
            <div className={localClasses.circleContainer} onClick={() => this.attemptPush('/')}>
              <ProgressCircle
                stage={Stages.SIGNUP}
                current={this.props.location.pathname}
                circRef={r => this[Stages.SIGNUP].circle = r}
              />
            </div>
            <div className={localClasses.line}></div>
            <div className={localClasses.circleContainer} onClick={() => this.attemptPush('/questionnaire')}>
              <ProgressCircle
                stage={Stages.SURVEY}
                current={this.props.location.pathname}
                circRef={r => this[Stages.SURVEY].circle = r}
              />
            </div>
            <div className={localClasses.line}></div>
            <div className={localClasses.circleContainer} onClick={() => this.attemptPush('/qualify')}>
              <ProgressCircle
                stage={Stages.QUALIFY}
                current={this.props.location.pathname}
                circRef={r => this[Stages.QUALIFY].circle = r}
              />
            </div>
            <div className={localClasses.line}></div>
            <div className={localClasses.circleContainer} onClick={() => this.attemptPush('/bonus')}>
              <ProgressCircle
                stage={Stages.BONUS}
                current={this.props.location.pathname}
                circRef={r => this[Stages.BONUS].circle = r}
              />
            </div>
          </div>

        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js